import { render } from "./page-footer.vue?vue&type=template&id=2c1510f0&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"

import "./page-footer.vue?vue&type=style&index=0&id=2c1510f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1510f0"]])

export default __exports__